document.addEventListener('DOMContentLoaded', function() {
    function daojishi(scopeContainer, endtime) {
        const countdownWrap = scopeContainer.querySelector('.js_djclose');
        const dayWrap = scopeContainer.querySelector('.day_wrap');
        const dayEl = scopeContainer.querySelector('.day_show');
        const hourEl = scopeContainer.querySelector('.hour_show');
        const minuteEl = scopeContainer.querySelector('.minute_show');
        const secondEl = scopeContainer.querySelector('.second_show');

        if (!countdownWrap || !hourEl || !minuteEl || !secondEl) {
            return;
        }

        const endTimeStamp = new Date(endtime).getTime();
        if (isNaN(endTimeStamp)) {
            countdownWrap.style.display = 'none';
            return;
        }

        let remainingSeconds = Math.floor((endTimeStamp - Date.now()) / 1000);
        if (remainingSeconds <= 0) {
            countdownWrap.style.display = 'none';
            return;
        }

        let lastDay = -1, lastHour = -1, lastMinute = -1, lastSecond = -1;

        function updateCountdown() {
            remainingSeconds = Math.floor((endTimeStamp - Date.now()) / 1000);
            if (remainingSeconds > 0) {
                const day = Math.floor(remainingSeconds / 86400);
                const hour = Math.floor((remainingSeconds % 86400) / 3600);
                const minute = Math.floor((remainingSeconds % 3600) / 60);
                const second = remainingSeconds % 60;

                const formatNum = num => num.toString().padStart(2, '0');
                const formattedHour = formatNum(hour);
                const formattedMinute = formatNum(minute);
                const formattedSecond = formatNum(second);

                // 处理天数的显示与隐藏
                if (dayWrap && dayEl) {
                    if (day > 0) {
                        dayWrap.style.display = 'inline';
                        if (day !== lastDay) {
                            dayEl.textContent = day;
                            lastDay = day;
                        }
                    } else {
                        dayWrap.style.display = 'none'; // 不足一天时直接隐藏天数
                    }
                }

                if (hour !== lastHour) {
                    hourEl.textContent = formattedHour; // 小时也补零
                    lastHour = hour;
                }
                if (minute !== lastMinute) {
                    minuteEl.textContent = formattedMinute;
                    lastMinute = minute;
                }
                if (second !== lastSecond) {
                    secondEl.textContent = formattedSecond;
                    lastSecond = second;
                }

                requestAnimationFrame(() => {
                    setTimeout(updateCountdown, 1000 - (Date.now() % 1000));
                });
            } else {
                countdownWrap.style.display = 'none';
                return;
            }
        }

        updateCountdown();
    }

    function initCountdown() {
        //const endTime = "2026-09-02T00:00:00Z";
        const endTime = "2026-09-02T00:00:00+02:00"; 

        const isProductDetailPage = window.location.pathname.includes('/products/');
        const isCollectionPage = window.location.pathname.includes('/collections/');
        const ishome = window.location.pathname === '/';

        if (isProductDetailPage) {
            const productDetailContainer = document.querySelector('.product-single, .product-detail');
            const scope = productDetailContainer || document.body;
            daojishi(scope, endTime);
        } else if (isCollectionPage) {
            const productItems = document.querySelectorAll('.grid__item, .product-card');
            productItems.forEach(item => {
                daojishi(item, endTime);
            });
        } else if (ishome) {
            const productItems = document.querySelectorAll('.grid__item, .product-card, .home-product-item');
            productItems.forEach(item => {
                daojishi(item, endTime);
            });
        } else {
            return;
        }
    }

    initCountdown();
});